import Icon from '../../Icon/Icon';
import { IconKeys } from '../../Icon/IconKeys';
import S from './LabeledIconStyles';

type Props = {
  label: string | JSX.Element | undefined
  icon: IconKeys,
  flexible?: boolean,
  width?: string | undefined,
  iconClass?: string,
  onClick?: any,
  backgroundColor?: string;
  textColor?: string;
};

function LabeledIcon({
  label, icon, flexible, width, iconClass = '', onClick, backgroundColor, textColor,
}: Props):JSX.Element {
  return (
    <S.Wrapper $width={width} onClick={onClick} style={{ backgroundColor }} $textColor={textColor}>
      <Icon iconKey={icon} className={iconClass} />
      <p
        className={flexible ? '' : 'fixed'}
        title={typeof (label) === 'string' ? label : ''}
      >{label}
      </p>
    </S.Wrapper>
  );
}

export default LabeledIcon;
